'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'sortDropdown', () => ({

		open: false,
		selected: 'event_start_date_desc',
		pendingValue: null,
		root: null,

		// `$el` is only reliable synchronously, scoped to whatever directive
		// Alpine is currently evaluating — a handler declared on a child
		// element (e.g. `@click` on one of the option labels) sees `$el` as
		// THAT element, not the component root, and it can drift further
		// once any async gap (setTimeout, MutationObserver, ...) is
		// involved. Store a plain reference once, here in init() where
		// `$el` is guaranteed to be the root, and use `this.root` everywhere
		// else instead of ever touching `$el` again.
		init() {
			this.root = this.$el;

			this.$nextTick( () => {
				const select = this.root.querySelector( '.facetwp-type-sort select' );

				if ( select && select.value ) {
					this.selected = select.value;
				}
			});
		},

		// FacetWP renders this facet as an empty shell and hydrates the real
		// <select> into it asynchronously via its own front-end JS — and
		// appears to rebuild it more than once during the first few seconds
		// after page load, so it can also be transiently ABSENT again right
		// after it first appears. Poll instead of a single lookup so a click
		// during that window still applies once things settle, rather than
		// silently doing nothing.
		applyWhenReady( value ) {
			this.pendingValue = value;

			let attempts = 0;

			const tryApply = () => {
				if ( this.pendingValue !== value ) return; // superseded by a newer click

				const select = this.root.querySelector( '.facetwp-type-sort select' );

				if ( select ) {
					select.value = value;
					select.dispatchEvent( new Event( 'change', { bubbles: true } ) );
					this.pendingValue = null;
					return;
				}

				if ( ++attempts < 50 ) {
					setTimeout( tryApply, 100 );
				}
			};

			tryApply();
		},

		select( value ) {
			this.selected = value;
			this.open     = false;
			this.applyWhenReady( value );
		},
	}) );
});
